import { render } from "./RequestSupportForm.vue?vue&type=template&id=6507bf34&ts=true"
import script from "./RequestSupportForm.vue?vue&type=script&lang=ts"
export * from "./RequestSupportForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Profile/RequestSupportForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6507bf34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6507bf34', __exports__)) {
    api.reload('6507bf34', __exports__)
  }
  
  module.hot.accept("./RequestSupportForm.vue?vue&type=template&id=6507bf34&ts=true", () => {
    api.rerender('6507bf34', render)
  })

}


export default __exports__